import { Button } from "@radix-ui/themes";
import { usePayment } from "../payment/payment-context";
import { useTranslation } from "react-i18next";
import { CheckoutResponse } from "../../api/hitl-api";
import { PaymentType } from "../../api/types";
import { useAppDispatch } from "../../store";
import { setPaymentArgs } from "../../store/slices/modalsSlice";
import { sanitizeErrorMessage } from "../../api/helpers/error";

export function TerminalPayment({
  isCompleted,
}: {
  isCompleted: boolean;
  lines?: CheckoutResponse["result"]["lines"];
}) {
  const { makePayment, loading } = usePayment();
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const handlePayment = async () => {
    try {
      await makePayment({ type: PaymentType.Terminal });
    } catch (error) {
      const errorStatus = sanitizeErrorMessage((error as any).data);
      dispatch(
        setPaymentArgs({
          hasError: true,
          checkoutId: null,
          type: PaymentType.Terminal,
          errorStatus,
        })
      );
    }
  };

  return (
    <Button
      size="4"
      variant="classic"
      className="relative"
      loading={!isCompleted || loading === "terminal"}
      onClick={handlePayment}
    >
      <div className="absolute glow inset-0"></div>
      {t("terminalPayment")}
    </Button>
  );
}
